import { abortIfNotPermitted } from '../../utils';

export default [
    {
        path: '/',
        component: () =>
            import(/* webpackChunkName: "stock-return" */ '@js/franchise_component/franchise-inventory/stock-return/stock-return-index.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_view_inventory_stock_return',
                next,
            );
        },
    },
    {
        path: '/create',
        component: () =>
            import(/* webpackChunkName: "stock-return-create" */ '@js/franchise_component/franchise-inventory/stock-return/stock-return-create.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_manage_inventory_stock_return',
                next,
            );
        },
    },
    {
        path: '/:id',
        component: () =>
            import(/* webpackChunkName: "stock-return-create" */ '@js/franchise_component/franchise-inventory/stock-return/stock-return-edit.vue'),
        beforeEnter: (to, from, next) => {
            return abortIfNotPermitted(
                'franchise_view_inventory_stock_return',
                next,
            );
        },
    },
];



// WEBPACK FOOTER //
// ./resources/assets/js/router/route-components/franchise-inventory/stock-return.js